import m from "../../geodata/es2015/costaRicaLow";
window.am4geodata_costaRicaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/costaRicaLow.js
// module id = null
// module chunks = 